import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledProgressbar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 15px;
  ul,
  li {
    list-style: none;
  }
  ul {
    display: flex;
    justify-content: space-between;
    min-width: auto;
  }
  li {
    width: 20px;
    height: 3px;
    border-radius: 1.5px;
    background: rgba(255, 255, 255, 0.3);
    transition: background 0.5s ease-in;
    margin: 0 2.5px;
  }
  .activePage {
    background: rgba(255, 255, 255, 1);
  }
`;

class Progressbar extends Component {
  render = () => {
    const { activePage, pageCount } = this.props;
    return (
      <StyledProgressbar className="revieve-progess-bar">
        {pageCount && activePage > -1 ? (
          <ul>
            {[
              ...Array(pageCount - 1)
                .fill()
                .map((e, i) => {
                  return <li key={i} className={i <= activePage ? 'activePage' : ''} />;
                }),
            ]}
          </ul>
        ) : null}
      </StyledProgressbar>
    );
  };
}

Progressbar.propTypes = {
  activePage: PropTypes.number,
  pageCount: PropTypes.number,
};

export default Progressbar;



// WEBPACK FOOTER //
// ./src/components/instore/Progressbar.js